module.exports = __webpack_public_path__ + "img/gift4.c114e93e.png";